<mat-expansion-panel>
    <mat-expansion-panel-header>
        <mat-panel-title>
            Prospect Property Status
        </mat-panel-title>
        <mat-panel-description>
            <div class="status-list">
                <div class="status-count">
                    <div class="red"></div>
                    <div class="count">({{redStatusCount$ | async}})</div>
                </div>

                <div class="status-count">
                    <div class="yellow"></div>
                    <div class="count">({{yellowStatusCount$ | async}})</div>
                </div>

                <div class="status-count">
                    <div class="green"></div>
                    <div class="count">({{greenStatusCount$ | async}})</div>
                </div>
            </div>
        </mat-panel-description>
    </mat-expansion-panel-header>


    <table class="table">
        <thead>
            <tr>
                <th scope="col"></th>
                <th scope="col">Address</th>
                <th scope="col">Status</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let cp of properties$ | async">
                <td>
                    <div [ngClass]="getPropertyStatusColor(cp?.pricingStatusId)"></div>
                </td>
                <td>
                    {{cp.propertyInfo?.address + ' ' + cp.propertyInfo?.city + ', ' + cp.propertyInfo?.state }}
                </td>
                <td>{{cp.pricingStatus}}</td>
                <td>
                    <div class="float-end ellipsisMenuWrapper">
                        <button mat-button [matMenuTriggerFor]="LoanActionMenu">
                            <fa-icon style="font-size:16px;" icon="bars"></fa-icon>
                        </button>
                        <mat-menu #LoanActionMenu="matMenu">
                            <div class="ellipsisMenuContent">
                                <button (click)="goToDashboardClicked(cp?.propertyInfo?.id)" mat-menu-item><fa-icon
                                        icon="chart-line"></fa-icon>&nbsp;&nbsp;
                                    Dashboard</button>
                                <button
                                    *ngIf="(lgvUserService.IsReadyForPricing$ | async) && cp.pricingStatus === 'Ready for Pricing' && (lgvCompanySvc.isMortgageCompany$ | async)"
                                    mat-menu-item (click)="onPriceThisScenario(cp)"><fa-icon
                                        style="font-size:18px !important;" icon="dollar-sign"></fa-icon>&nbsp;&nbsp;
                                    Price</button>

                            </div>

                        </mat-menu>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</mat-expansion-panel>